import { Expose, Type } from 'class-transformer';
import { IManager } from '../interfaces/auth.interface';

export class ManagerDTO implements IManager {
  id!: string;

  name!: string;

  email!: string;

  role!: 'ADMIN' | 'MANAGER';

  isBlocked!: boolean;

  @Type(() => Date)
  creationDate!: Date;

  @Expose()
  get status() {
    return this.isBlocked ? 'Bloqueado' : 'Activo';
  }

  @Expose()
  get displayedRole() {
    return this.role === 'ADMIN' ? 'Administrador' : 'Usuario';
  }
}
